import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature, IUserAccessSubFeatures} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureCopySettings
export interface IFeatureCopySettings extends IUserAccessFeature, IUserAccessSubFeatures, Object {
}

//#endregion

//#region CONST _FEATURE_COPY_SETTINGS_DEFAULT
export const _FEATURE_COPY_SETTINGS_DEFAULT: Readonly<IFeatureCopySettings & Object> = {
  displayText: NavigationPageEnumHumanReadable.CopySettings,
  feature: NavigationPageEnum.CopySettings,
  ref: SettingsReferenceEnum.featureCopySettings,
  standalone: true,
};
//#endregion
